function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle",
  d: "M42.874,33.711a3.707,3.707,0,0,0,3.442-2.331L58.081,1.943A3.089,3.089,0,0,1,60.95,0H89.484A1.853,1.853,0,0,1,91.2,2.555L65.744,64.8a3.089,3.089,0,0,1-2.859,1.92H.333A1.236,1.236,0,0,1-.809,65.015l12.17-29.4a3.089,3.089,0,0,1,2.854-1.907Z",
  transform: "translate(0.904 0)",
  fill: "#b95669",
  opacity: 0.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2",
  "data-name": "Rectangle",
  d: "M43.778,33.711A3.707,3.707,0,0,0,47.22,31.38L58.986,1.943A3.089,3.089,0,0,1,61.854,0H90.389A1.853,1.853,0,0,1,92.1,2.555L66.648,64.8a3.089,3.089,0,0,1-2.859,1.92H1.237A1.236,1.236,0,0,1,.1,65.015l12.17-29.4a3.089,3.089,0,0,1,2.854-1.907Z",
  transform: "translate(120 108.8) rotate(180)",
  fill: "#869dab",
  opacity: 0.8
});

var SvgApLogo = function SvgApLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    width: 120,
    height: 108.8,
    viewBox: "0 0 120 108.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ap-logo.8e2b6486.svg";
export { ForwardRef as ReactComponent };